import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../utils/AuthService";

function Authorized({ children, refRoute }) {
  console.log("refRoute", refRoute);

  // store the route user was trying to access before login
  localStorage.setItem("refRoute", refRoute);

  // if not logged in → redirect to Signin
  if (!AuthService.isLoggedIn()) {
    return <Navigate to="/Signin" replace />;
  }

  // if logged in → render children
  return children;
}

export default Authorized;
